import { client } from '@/services/api/axios.ts';
import { keepPreviousData, useQuery } from '@tanstack/react-query';

export type PlantsRankingItemResponse = {
  plantId: string;
  plantName: string;

  plantImageName: string | undefined;
  signedImageExpiresAt: string | undefined;
  signedImageUrl: string | undefined;

  storageCapacity: number;
  chargedEnergy: number | string;
  dischargedEnergy: number | string;
  energyThroughput: number | string;
};

export type PlantsRankingResponse = PlantsRankingItemResponse[];

export const useGetPlantsRankingQuery = ({ enabled = true }: { enabled?: boolean } = {}) => {
  return useQuery({
    queryKey: ['plants', 'ranking'],
    queryFn: async () => {
      const { data } = await client.get<{ body: PlantsRankingResponse }>(`/plants/ranking`);

      return data.body;
    },
    refetchInterval: 1000 * 60 * 5,
    placeholderData: keepPreviousData,
    enabled,
  });
};
